<template>
  <div style="margin-top: 2rem">
    <commonQueryInput :inputItems="workInputItems" v-model:getValue="workInputVal"></commonQueryInput>
    <commonQueryInput :inputItems="multiInputItems" :immediateInputValues="true" v-model:getValue="multiInputVal"
      v-model:getImmediateValue="immediateMultiInputVal"></commonQueryInput>

    <div class="text-end" style="margin-bottom: 0.6rem">
      <exportCsv :exportData="completeWorkItems" :exportDataTitle="completeWorkFields.map((item) => item.label)"
        :exportFileName="exportFileName()" />
    </div>
    <commonTable :fields="completeWorkFields" :items="completeWorkItems" :theme="'green'" :rowClick="rowClick"
      stickyHeader="550px">
      <template #cell(work_qty)="data">{{
      isNaN(Number(data.value))
        ? data.value
        : Number(data.value).toLocaleString("en-US")
        }}</template>
    </commonTable>
  </div>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import exportCsv from "@/components/exportCsv.vue";
import commonTable from "@/components/commonTable.vue";

import { ref } from "@vue/reactivity";
import { computed, inject, watch } from "@vue/runtime-core";
import { useStore } from "vuex";
export default {
  components: {
    commonQueryInput,
    exportCsv,
    commonTable,
  },
  setup() {
    const store = useStore();
    const mainContent = inject("mainContent");
    const completeWorkItems = inject("completeWorkItems");
    const wip_lot = inject("wip_lot");
    const detail = inject("detail");

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const oper = computed(() => store.getters["selectOptions/get_oper"]);
    const device = computed(() => store.getters["selectOptions/get_device"]);

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
      set_device: (payload) => {
        store.dispatch("selectOptions/set_device", payload);
      },
    };

    /************** 第一行輸入框 **************/
    const workInputVal = ref();
    const workInputItems = [
      {
        key: "wip_lot",
        label: "派工單號",
        type: "text", // date/dateBetween/text/select/
        checkEmpty: true,
      },
    ];
    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      workInputVal,
      (newValue) => {
        methods.triggerLoadingBar();
        let params = {};
        params["webPage"] =
          sideNavPath.value.length != 0
            ? sideNavPath.value[sideNavPath.value.length - 1]
            : null;
        params["user"] = loginData.value.account;
        params["vuePage"] = "workorderhistory";
        params["methods"] = "POST";
        params["whichFunction"] = "MainQuery";
        params["wip_lot"] = newValue["wip_lot"];
        params["singleWorkIdQuery"] = true;
        methods.axiosAction(params).then(() => {
          console.log(axiosResult.value);
          let result = axiosResult.value;
          let response = result.Response;
          if (response == "ok") {
            let QueryTableData = result.QueryTableData;
            QueryTableData = QueryTableData.sort(function (a, b) {
              return a.lastUpdateTime < b.lastUpdateTime ? 1 : -1;
            });
            completeWorkItems.value = QueryTableData;
          } else {
            completeWorkItems.value = [];
            methods.setTimeoutAlert(response);
          }
          methods.triggerLoadingBar();
        });
      },
      { deep: true }
    );

    /************** 第二行輸入框 **************/
    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "date",
        label: "日期",
        type: "dateBetween", // date/dateBetween/text/select/
      },
      {
        key: "oper",
        label: "製程",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇製程 --",
        options: oper,
      },
      {
        key: "deviceID",
        label: "機台",
        type: "select",
        bindKey: "oper",
        checkEmpty: true,
        disableText: "-- 選擇機台 --",
        bindOptions: device,
      },
      {
        key: "prodID",
        label: "產品料號",
        type: "text",
      },
    ]);
    const immediateMultiInputVal = ref();

    //查詢回來的機台名稱
    const deviceName = ref("");

    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        methods.triggerLoadingBar();
        let params = {};
        params["webPage"] =
          sideNavPath.value.length != 0
            ? sideNavPath.value[sideNavPath.value.length - 1]
            : null;
        params["user"] = loginData.value.account;
        params["vuePage"] = "workorderhistory";
        params["methods"] = "POST";
        params["whichFunction"] = "MainQuery";
        params["startTime"] = newValue["date"]["startDate"] + " 00:00:00";
        params["endTime"] = newValue["date"]["endDate"] + " 23:59:59";
        newValue["oper"] != undefined
          ? (params["oper"] = newValue["oper"])
          : "";

        newValue["deviceID"] != undefined
          ? (params["deviceID"] = newValue["deviceID"])
          : "";

        newValue["prodID"] != undefined
          ? (params["prodID"] = newValue["prodID"])
          : "";

        methods.axiosAction(params).then(() => {
          console.log(axiosResult.value);
          let result = axiosResult.value;
          let response = result.Response;
          if (response == "ok") {
            let QueryTableData = result.QueryTableData;
            QueryTableData = QueryTableData.sort(function (a, b) {
              return a.lastUpdateTime < b.lastUpdateTime ? 1 : -1;
            });
            completeWorkItems.value = QueryTableData;
          } else {
            completeWorkItems.value = [];
            if (response == 'no data') {
              response = '查無資料';
            }
            methods.setTimeoutAlert(response);
          }
          methods.triggerLoadingBar();
        });
      },
      { deep: true }
    );

    const startTime = ref("");
    const process = ref("");
    // 查詢機台
    watch(
      immediateMultiInputVal,
      (newValue) => {
        if (newValue.date == "" || newValue.date == null) {
          if (
            newValue.date.startDate == "" ||
            newValue.date.startDate == null
          ) {
            return;
          }
        }
        if (newValue.oper == "" || newValue.oper == null) {
          return;
        }
        if (
          startTime.value == newValue.date.startDate &&
          process.value == newValue.oper
        ) {
          return;
        }
        let params = {};
        params["user"] = loginData.value.account;
        params["vuePage"] = "selectoption";
        params["methods"] = "GET";
        params["whichFunction"] = "GetDeviceOption";
        if (newValue.date != "" || newValue.date != null) {
          if (
            newValue.date.startDate != "" ||
            newValue.date.startDate != null
          ) {
            params["startTime"] = newValue.date.startDate;
          }
        }
        if (newValue.oper != "" || newValue.oper != null) {
          params["process"] = newValue.oper;
        } else {
          params["process"] = "-";
        }
        methods.axiosAction(params).then(() => {
          let result = axiosResult.value;
          if (result["Response"] == "ok") {
            methods.set_device(result.QueryTableData.device);
            startTime.value = newValue.date.startDate;
            process.value = newValue.oper;
          } else {
            let returnData = {};
            returnData[params.process] = [];
            methods.set_device(returnData);
            startTime.value = "";
            process.value = "";
          }
        });
      },
      { deep: true }
    );

    /************** table **************/
    const completeWorkFields = [
      {
        key: "wip_lot",
        label: "工單",
        sortable: true,
        thStyle: {
          width: "120px",
          "min-width": "120px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "oper_schedule",
        label: "製程進度",
        sortable: true,
        thStyle: {
          width: "120px",
          "min-width": "120px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "prod_id",
        label: "料名",
        sortable: true,
        thStyle: {
          width: "250px",
          "min-width": "250px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "work_qty",
        label: "派工數量",
        sortable: true,
        thStyle: {
          width: "120px",
          "min-width": "120px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "completion_date",
        label: "完工日期",
        sortable: true,
        thStyle: {
          width: "190px",
          "min-width": "190px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    //每一行的點擊事件
    const rowClick = (itemData) => {
      console.log(itemData);
      mainContent.value.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      wip_lot.value = itemData.wip_lot;
      detail.value = true;
    };

    //匯出資料的檔案名稱
    const exportFileName = () => {
      let exportFileName = "";
      if (deviceName.value != "") {
        exportFileName =
          "工單履歷_" +
          deviceName.value +
          "_" +
          new Date().getFullYear() +
          ("0" + (new Date().getMonth() + 1)).slice(-2) +
          ("0" + new Date().getDate()).slice(-2);
      }
      return exportFileName;
    };

    //測試用
    // setTimeout(() => {
    //   items.value.push({
    //     workID: "38044X",
    //     work_org_code: "38044X",
    //     processSchedule: "輾牙線邊倉",
    //     product_name_chinese:
    //       "DIN 933/ISO 4017 六角頭螺栓 調質8.8級 全牙 M5-0.8X100mm 8.8,OF 鍍鋅 5um+三價鉻+氫脆烘0小時+8小時白鏽+24小時紅鏽 ASTM F1941 N/A",
    //     work_qty: 16160,
    //     completion_date: "--",
    //   });
    // }, 500);

    return {
      workInputItems,
      workInputVal,
      multiInputVal,
      multiInputItems,
      immediateMultiInputVal,
      completeWorkFields,
      completeWorkItems,
      rowClick,
      exportFileName,
    };
  },
};
</script>

<style></style>
